export default __webpack_public_path__ + "static/media/ADMI_White_logo-01.9f4a7a8b.png";